import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={16}
    fill="none"
    viewBox="0 0 9 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.833 7.083c-1.891-.491-2.5-1-2.5-1.791 0-.909.842-1.542 2.25-1.542 1.184 0 1.775.45 1.992 1.167.1.333.375.583.725.583h.25a.79.79 0 0 0 .75-1.058c-.35-.984-1.167-1.8-2.467-2.117V1.75c0-.692-.558-1.25-1.25-1.25-.691 0-1.25.558-1.25 1.25v.55C1.717 2.65.417 3.7.417 5.308c0 1.925 1.591 2.884 3.916 3.442 2.084.5 2.5 1.233 2.5 2.008 0 .575-.408 1.492-2.25 1.492-1.375 0-2.083-.492-2.358-1.192-.125-.325-.408-.558-.75-.558h-.233A.795.795 0 0 0 .5 11.583c.475 1.159 1.583 1.842 2.833 2.109v.558c0 .692.559 1.25 1.25 1.25.692 0 1.25-.558 1.25-1.25v-.542c1.625-.308 2.917-1.25 2.917-2.958 0-2.367-2.025-3.175-3.917-3.667"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMoney;
